import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  selectDetailsRDV,
  setIsEditing,
} from "../../store/slices/rendezVousSlice";
import InterventionDetails from "../../components/InterventionDetails";
import { useLoadScript } from "@react-google-maps/api";
import LocationAutocomplete from "../../components/LocationAutocomplete";
import PhoneInput from "react-phone-number-input";
import { isValidEmail } from "../../utils/utils";
import { toast } from "react-toastify";
import { isValidPhoneNumber } from "react-phone-number-input";
const InterventionTypeSelector = ({
  onInterventionChange,
  prestations = null,
}) => {
  const dispatch = useDispatch();

  const interventionTypes = [
    { id: "chezpro", label: "Chez le professionnel" },
    { id: "onsite", label: "À domicile" },
    { id: "enligne", label: "En ligne" },
  ];

  // State
  const [contactPreference, setContactPreference] = useState("telephone");
  const [address, setAddress] = useState({ rue: "", ville: "" });
  const [phoneNumber, setPhoneNumber] = useState("");
  const [email, setEmail] = useState("");
  const [selectedIntervention, setSelectedIntervention] = useState(null);
  const [street, setStreet] = useState("");
  const [city, setCity] = useState("");
  const [lat, setLat] = useState(null);
  const [lng, setLng] = useState(null);
  const [postalCode, setPostalCode] = useState(null);

  // Selectors
  const detailsRDV = useSelector(selectDetailsRDV);
  const isEditing = useSelector((state) => state.rendezvous.isEditing);
  const reduxPrestations = useSelector(
    (state) => state.rendezvous.selectedPrestations
  );
  const effectivePrestations = prestations || reduxPrestations || [];

  const availableInterventions = Array.from(
    new Set(
      effectivePrestations
        .filter((presta) => presta?.selected)
        .flatMap((presta) => presta.lieu || [])
    )
  );
  useEffect(() => {
    // Seulement si en mode édition ou si c'est l'initialisation
    if (isEditing || !detailsRDV) {
      if (!selectedIntervention && availableInterventions.length > 0) {
        let defaultType = availableInterventions.includes("chezpro") 
          ? "chezpro" 
          : availableInterventions[0];
        
        setSelectedIntervention(defaultType);
       // handleInterventionChange(defaultType)
        // Ne pas appeler onInterventionChange ici pour éviter la boucle
      }
    }
  }, [availableInterventions, isEditing, detailsRDV]);
  useEffect(() => {
    if (selectedIntervention && !detailsRDV?.type) {
      onInterventionChange({
        type: selectedIntervention,
        rue: street,
        ville: city,
        contact: contactPreference,
        valueContact: contactPreference === "telephone" ? phoneNumber : email,
      });
    }
  }, [selectedIntervention]);
  // Un autre useEffect pour gérer la synchronisation avec les données existantes
  useEffect(() => {
    if (detailsRDV && !isEditing) {
      setSelectedIntervention(detailsRDV.type);
      setStreet(detailsRDV.rue || "");
      setCity(detailsRDV.ville || "");
      setContactPreference(detailsRDV.contact || "telephone");
      // Pas besoin d'appeler onInterventionChange ici
    }
  }, [detailsRDV, isEditing]);

  const handleInterventionChange = (typeId) => {
    setSelectedIntervention(typeId);
    onInterventionChange({
      type: typeId,
      rue: street,
      ville: city,
      contact: contactPreference,
      valueContact: contactPreference === "telephone" ? phoneNumber : email,
    });
  };

  const handleAddressChange = (e) => {
    const { value, name } = e.target;
    if (name === "rue") {
      setStreet(value);
      setAddress((prev) => ({ ...prev, rue: value }));
    } else if (name === "ville") {
      setCity(value);
      setAddress((prev) => ({ ...prev, ville: value }));
    }
    onInterventionChange({
      type: selectedIntervention,
      rue: name === "rue" ? value : street,
      ville: name === "ville" ? value : city,
      contact: contactPreference,
      valueContact: contactPreference === "telephone" ? phoneNumber : email,
    });
  };

  const libraries = ["places"];
  const { isLoaded } = useLoadScript({
    googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY,
    libraries,
  });

  const handleLocationSelect = (place) => {
    if (!place) {
      setStreet("");
      setCity("");
      setLat(null);
      setLng(null);
      setPostalCode(null);
      setAddress({ rue: "", ville: "" });
    } else {
      setStreet(place.description);
      setAddress((prev) => ({ ...prev, rue: place.description }));

      if (isLoaded && window.google && window.google.maps) {
        const geocoder = new window.google.maps.Geocoder();
        geocoder.geocode({ placeId: place.place_id }, (results, status) => {
          if (status === window.google.maps.GeocoderStatus.OK && results[0]) {
            const { lat: googleLat, lng: googleLng } =
              results[0].geometry.location;
            let city = "";
            let postalCode = "";

            results[0].address_components.forEach((component) => {
              if (component.types.includes("locality")) {
                city = component.long_name;
              }
              if (component.types.includes("postal_code")) {
                postalCode = component.long_name;
              }
            });

            setLat(googleLat());
            setLng(googleLng());
            setPostalCode(postalCode);
            setCity(city);
            setAddress((prev) => ({ ...prev, ville: city }));
          }
        });
      }
    }
    // console.log('hereeeee')
    onInterventionChange({
      type: selectedIntervention,
      rue: place?.description || "",
      ville: city,
      contact: contactPreference,
      valueContact: contactPreference === "telephone" ? phoneNumber : email,
    });
  };

  const handleContactPreferenceChange = (type) => {
    setContactPreference(type);
    onInterventionChange({
      type: selectedIntervention,
      rue: street,
      ville: city,
      contact: type,
      valueContact: type === "telephone" ? phoneNumber : email,
    });
  };

  const handlePhoneNumberChange = (value) => {
    setPhoneNumber(value || ""); // Handle undefined case
   
    onInterventionChange({
      type: selectedIntervention,
      rue: street,
      ville: city,
      contact: contactPreference,
      valueContact: value || "",
    });
  };

  const handleEmailChange = (e) => {
    const value = e.target.value;

    setEmail(value);
    onInterventionChange({
      type: selectedIntervention,
      rue: street,
      ville: city,
      contact: contactPreference,
      valueContact: value,
    });
  };

  const formattedIntervention = detailsRDV
    ? {
        ...detailsRDV,
        lieu_intervention: detailsRDV?.type,
      }
    : null;

  return (
    <div className="intervention-selector mt-32">
      <h3 className="grey500">Intervention</h3>
      {!isEditing && detailsRDV?.type ? (
        <InterventionDetails
          intervention={formattedIntervention}
          onEdit={() => {
            dispatch(setIsEditing(true));
          }}
          edit={true}
        />
      ) : (
        <>
          <div className="intervention-options d-flex   gap-2 mt-24">
            {interventionTypes.map((type) => {
              const isDisabled = !availableInterventions.includes(type.id);
              const isChecked = selectedIntervention === type.id && !isDisabled;
              return (
                <div
                  key={type.id}
                  className={`intervention-option w-100 border-card mr-8 ${
                    isDisabled ? "disabled" : ""
                  }`}
                >
                  <label className="d-flex align-items-center ">
                    <input
                      type="radio"
                      id={type.id}
                      name="intervention"
                      value={type.id}
                      onChange={() => handleInterventionChange(type.id)}
                      disabled={isDisabled}
                      checked={isChecked}
                    />
                    <span className="custom-radio"></span> {type.label}
                  </label>
                </div>
              );
            })}
          </div>
          {selectedIntervention === "onsite" && (
            <div className="mt-24">
              <h4 className="grey500">Adresse du domicile</h4>
              <div className="row mt-16">
                <div className="input-wrapper col-md-6">
                  <label className="form-label">Rue et numéro</label>
                  <div className="relative">
                    <LocationAutocomplete
                      onLocationSelect={handleLocationSelect}
                      isGoogleLoaded={isLoaded}
                      value={street}
                    />
                  </div>
                </div>
                <div className="input-wrapper col-md-6">
                  <label className="form-label">Ville</label>
                  <input
                    type="text"
                    name="ville"
                    value={city}
                    onChange={handleAddressChange}
                    placeholder="75006 Paris"
                    className="form-control"
                  />
                </div>
              </div>
            </div>
          )}

          {selectedIntervention === "onsite" && (
            <div className="mt-24">
              <h4 className="grey500">Préférence de contact</h4>
              <div className="d-flex mt-16">
                <div className="mr-8 border-card w-100">
                  <label className="d-flex align-items-center">
                    <input
                      type="radio"
                      name="contactPreference"
                      checked={contactPreference === "telephone"}
                      onChange={() =>
                        handleContactPreferenceChange("telephone")
                      }
                    />
                    <span className="custom-radio"></span> Téléphone
                  </label>
                </div>
                <div className="border-card w-100">
                  <label className="d-flex align-items-center">
                    <input
                      type="radio"
                      name="contactPreference"
                      checked={contactPreference === "email"}
                      onChange={() => handleContactPreferenceChange("email")}
                    />
                    <span className="custom-radio"></span> Email
                  </label>
                </div>
              </div>

              {contactPreference === "telephone" && (
                <div className="input-wrapper col-md-6 mt-16">
                  <label className="grey500 mb-0">Numéro de téléphone*</label>
                  <PhoneInput
                    excludeCountries={[]}
                    international
                    name="contactValue"
                    defaultCountry="FR"
                    value={phoneNumber}
                    onChange={handlePhoneNumberChange}
                    onBlur={() => {
                      if (phoneNumber && !isValidPhoneNumber(phoneNumber)) {
                        toast.error("Numéro de téléphone invalide");
                      }
                    }}
                    id="telephone"
                    className="mt-8"
                    placeholder="06 45 63 78 73"
                  />
                </div>
              )}
              {contactPreference === "email" && (
                <div className="input-wrapper col-md-6 mt-16">
                  <label className="grey500 mb-0">Email*</label>
                  <input
                    type="email"
                    name="contactValue"
                    value={email}
                    onChange={handleEmailChange}
                    placeholder="example@domain.com"
                    className={`mt-8  ${
                      email && !isValidEmail(email) ? "is-invalid" : ""
                    }`}
                  />
                  {email && !isValidEmail(email) && (
                    <div className="invalid-feedback">
                      Veuillez entrer une adresse email valide
                    </div>
                  )}
                </div>
              )}
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default InterventionTypeSelector;
